module.exports = __webpack_public_path__ + "static/media/innovative.c42323c6.png";